/**
 * PATH: apps/ai/src/pages/dashboard/AlertItem.tsx
 * PURPOSE: Alert item component for the Intelligence sidebar
 */

import { AlertCircle, AlertTriangle, Info, Briefcase, ArrowUpRight } from 'lucide-react';
import { cn } from '../../lib/utils';
import type { Alert } from './types';

const severityStyles = {
  critical: { bg: "bg-red-500/10", border: "border-red-500/30", icon: "text-red-600 bg-red-100 dark:bg-red-900/50", text: "text-red-700 dark:text-red-400" },
  warning: { bg: "bg-amber-500/10", border: "border-amber-500/30", icon: "text-amber-600 bg-amber-100 dark:bg-amber-900/50", text: "text-amber-700 dark:text-amber-400" },
  info: { bg: "bg-blue-500/10", border: "border-blue-500/30", icon: "text-blue-600 bg-blue-100 dark:bg-blue-900/50", text: "text-blue-700 dark:text-blue-400" },
};

export function AlertItem({ alert, onClick }: { alert: Alert; onClick: () => void }) {
  const style = severityStyles[alert.type];
  const Icon = alert.type === "critical" ? AlertCircle : alert.type === "warning" ? AlertTriangle : Info;

  return (
    <button onClick={onClick} className={cn(
      "w-full flex items-start gap-2.5 p-2.5 rounded-xl border text-left transition-all hover:shadow-md group",
      style.bg, style.border,
    )}>
      <div className={cn("p-1.5 rounded-lg flex-shrink-0", style.icon)}>
        <Icon className="w-3 h-3" />
      </div>
      <div className="flex-1 min-w-0">
        <p className={cn("text-[11px] font-medium leading-snug", style.text)}>{alert.message}</p>
        {alert.jobName && (
          <p className="text-[9px] text-muted-foreground mt-0.5 flex items-center gap-1">
            <Briefcase className="w-2.5 h-2.5" />{alert.jobName}
          </p>
        )}
      </div>
      <ArrowUpRight className="w-3.5 h-3.5 text-muted-foreground opacity-0 group-hover:opacity-100 transition-opacity" />
    </button>
  );
}
